import React, {Component} from 'react';
import DatePicker from "react-datepicker";
import {formatDate} from '../util/HelpfulFunctions';
import Picker from './Editors/Picker';

export function SummaryTile({title, value, subValue1, subTitle1, subValue2, subTitle2, size, textSize, color, colorSub, justify}) {

    if (!size) size = 4;
    if (!color) color = "primary3"
    if (!colorSub) colorSub = "primary4";
    if (!justify) justify = "start";
    
    if (!textSize) 
        textSize = 3;
    else
    {
        textSize = 6 - textSize;
        if (textSize < 1)
            textSize = 1;
    }

    var subTextSize = textSize + 2;
    if (subTextSize > 7)
        subTextSize = 7;


    return (
        <div className={`col-md-${size} grid-margin stretch-card`}>
            <div className="card aligner-wrapper">
                <div className="card-body">
                    <h5 className={`d-flex text-muted mb-4`}>{title}</h5>
                    {/* <hr className="mb-4" /> */}
                    {renderSubValues()}
                    <div className={`d-flex justify-content-${justify} font-weight-medium h${textSize} my-0 text-${color}`}>{value}</div>
                </div>
            </div>
        </div>
    );

    function renderSubValues() {
        if (subValue1 || subValue2) {
            return (
                <div>
                    {subValue1 ? (
                        <div className="row d-flex">
                            <div className="col text-align-left text-muted">{subTitle1}</div>
                            <div className={`col d-flex justify-content-${justify} font-weight-medium h${subTextSize} color-${colorSub}`}>{subValue1}</div>
                        </div>
                    ) : null}

                    {subValue2 ? (
                        <div className="row d-flex">
                            <div className="col text-align-left text-muted">{subTitle2}</div>
                            <div className={`col d-flex justify-content-${justify} font-weight-medium h${subTextSize} color-${colorSub}`}>{subValue2}</div>
                        </div>
                    ) : null}

                    <hr className= "mb-3 mt-2"/>
                </div>
            );
        }
    }
}


export function EditableTile({title, value, type, size, textSize, color, justify, className, onChange, itemsSource, displayMember, valueMember}) {

    if (!size) size = 4;
    if (!color) color = "primary3"
    if (!justify) justify = "end";

    if (!textSize) 
        textSize = 3;
    else
    {
        textSize = 5 - textSize;
        if (textSize < 1)
            textSize = 1;
    }
    
    // var style = onChange? {cursor: "pointer"} : null;

    return (
        <div className={`col-md-${size} grid-margin stretch-card p-0${className}`} >
            <div className="card aligner-wrapper">
                <div className="card-body">
                    {/* <div className={`absolute left right bottom h-strock-3 bg-${color}`} /> */}
                    <h5 className={`d-flex text-muted mb-4`}>{title}</h5>
                    {/* <hr className="mb-4" /> */}
                    <Editor className={`d-flex justify-content-${justify}`} 
                        value={value} 
                        type={type? type : typeof value} 
                        color={color} justify={justify} 
                        onChange={onChange}
                        itemsSource={itemsSource}
                        valueMember={valueMember}
                        displayMember={displayMember}
                        textSize={textSize}
                        />
                </div>
            </div>
        </div>
    );
}


function Editor({value, type, justify, onChange, color, itemsSource, displayMember, valueMember, textSize}) {

    if (type === "string")
        return (<input type="text" className={`d-flex justify-content-${justify} form-control`} text={value} onChange={onChange} />);
    else if (type === "number")
        return (<input type="numeric" className={`d-flex justify-content-${justify} form-control`} text={value} onChange={onChange} />);
    else if (type === "date") {
     
        if (onChange) {
            return (
                <DatePicker className={`tile-date-picker-${justify == "end" ? "right" : "left"} h3 font-weight-medium text-${color}`}
                    selected={Date.parse(value)}
                    value={formatDate(value)}
                    onChange={(value) => {
                        if (onChange)
                            onChange({ value: value })
                    }} />
            );
        }
        else {
            return (<div className={`d-flex justify-content-${justify} font-weight-medium h${textSize} my-0 text-${color}`}>{formatDate(value)}</div>);
        }
    }
    else if (type === "memo") {
        if (onChange) {
            return (
                <textarea rows="3" style={{ fontSize: ".9rem", lineHeight: "1.1rem" }} type="text" className="form-control text-left text-wrap text-normal m-auto font-size-normal" 
                        value={value} onChange={onChange}/>

            )
        }
        else {
            return <div className="text-left text-wrap text-normal">{value}</div>
        }
    }
    else if (type === "lookup") {
        return (
            <Picker 
                placeholder="Επιλέξτε..."
                itemsSource={itemsSource}
                displayMember={displayMember}
                valueMember={valueMember}
                selectedValue={value}
                onChange={onChange}
            />
        )
    }
    else
        return (<h2 className={`d-flex justify-content-${justify} font-weight-medium my-0 text-${color}`}>{value}</h2>);
}

function displayDatePicker(_event) {
    alert("Select input date");
}